import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function ISCcriteria() { 
  useEffect(() => {
    document.title = 'ISC Criteria -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>ISC</li>
                <li>ISC Criteria</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">ISC Criteria</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p><b>Admissions to standard XI (ISC) for students applying from outside schools:</b></p>
               <p>The Mercy Memorial School is one of the few schools in Kanpur which has standards XI & XII as part of its curriculum. Students seeking admission after their X standard should please note the following points:-</p>
               <p>Applications are to be made only after the Preliminary results are declared and if any vacancy exists.</p>
                 <h5>Applications are to be addressed to the Principal, mentioning:</h5>
                  <ul className="mainlist">
                       <li> Child’s name </li>
                       <li> School studying in </li>
                      <li> Contact numbers & Email are essential </li>
                      <li> Standard </li>
                 </ul>
                 <br/>
                  <h5>Attachments required with the Application are:</h5>
                   <ul className="mainlist">
                       <li> Copy of Birth Certificate.</li>
                       <li> Results of standard IX, X and Preliminary Examinations. (photocopies only) </li>
                      <li> Certificates of co-curricular/extra curricular activities. (photocopies only).</li>
                      <li> Incomplete applications will be disqualified. </li>
                   </ul>
                    <br/>
               <p>Enquiries regarding applications that have been submitted will not be entertained. The school will contact you only in case of a vacancy</p>
              
                  <h5>SUBJECT COMBINATION FOR ISC-STD XI</h5>
                    <p className="section"><b>Combination -1</b></p>
                    <div className="primarycourse">
                       <ul className="mainlist">
                           <li> English </li>
                           <li> Physics </li>
                           <li> Chemistry </li>
                           <li> Mathematics </li>
                           <li> Computer Science </li>
                       </ul>
                    </div>
                    <p className="section"><b>Combination -2</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li> English </li>
                           <li> Physics </li>
                           <li> Chemistry </li>
                           <li> Mathematics </li>
                           <li> Hindi </li>
                       </ul>
                    </div>
                     <p className="section"><b>Combination -3</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li> English </li>
                           <li> Physics </li>
                           <li> Chemistry </li>
                           <li> Mathematics </li>
                           <li>Biology   </li>
                       </ul>
                    </div>
                     <p className="section"><b>Combination -4</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li> English </li>
                           <li> Physics </li>
                           <li> Chemistry </li>
                           <li>Biology   </li>
                           <li>Hindi </li>
                       </ul>
                    </div>
                       <p className="section"><b>Combination -5</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li> English </li>
                           <li> Physics </li>
                           <li> Chemistry </li>
                           <li>Biology   </li>
                           <li>Bio-Technology</li>
                       </ul>
                    </div>
                       <p className="section"><b>Combination -6</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li> English </li>
                           <li> Physics </li>
                           <li> Chemistry </li>
                           <li>Hindi</li>
                           <li>Computer Science</li>
                       </ul>
                    </div>
                      <p className="section"><b>Combination -7</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li>  English </li>
                           <li> Economics </li>
                           <li> Commerce </li>
                           <li> Accounts </li>
                           <li> Mathematics </li>
                       </ul>
                    </div>
                      <p className="section"><b>Combination -8</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li>  English </li>
                           <li> Economics </li>
                           <li> Commerce </li>
                           <li> Accounts </li>
                           <li> Hindi </li>
                       </ul>
                    </div>
                     <br/>
                   <p> Student having a minimum aggregate of 80% in Mathematics & English in the Std. X will qualify for Science stream. If a student has not taken Mathematics in Std. X then he/she is not eligible for Science/Computer combination. </p>
                   <p> A minimum aggregate of 80% in English in the Std. X School exams will qualify a student for other Stream/Combination. </p>
                   <p> Admission to Class XI is provisional till the results of the ICSE Examination are declared. Students not qualifying in the ICSE Examination will automatically not be eligible to continue with the ISC (XII) course. </p>
                   <ul className="mainlist">
                           <li>It may not always be possible to admit all candidates who apply for admission to specific courses.</li>
                           <li> The Principal reserves the right to refuse admission/readmission to a candidate without assigning any reason. </li>
                           <li> Only candidates with a consistently good record in Mathematics/Science should opt for Science Stream. </li>
                  </ul>

              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ISCcriteria;
